module.exports = __webpack_public_path__ + "assets/img/tic-play.3801bfab.png";